import { Id, Tag } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";
import { LinkedList } from "../linkers/types";

function addTagToList(httpClient: HttpClient) {
  return (tag: Tag, listId: Id) =>
    httpClient
      .sendHttpRequest<LinkedList>({
        endpoint: `/activities/${listId}`,
        method: HttpMethods.GET,
      })
      .then((list) =>
        httpClient.sendHttpRequest<void>({
          endpoint: `/activities/${listId}`,
          method: HttpMethods.PATCH,
          data: { tags: [...list.tags, tag.name] },
        }),
      );
}

export { addTagToList };
